package it.neckar.lizergy.lifeCycle

import it.neckar.open.kotlin.lang.toCheckboxChar
import kotlinx.serialization.Serializable

/**
 * Lizergy-internal copy of [it.neckar.lifeCycle.LifeCycleState].
 *
 * Lizergy is maintenance-only and must not depend on the evolving commons `LifeCycleState`.
 * All three values are kept because `NearEndOfLive` and `EndOfLife` carry business meaning
 * in the planner workflow, independent from any soft-delete semantics.
 */
@Serializable
enum class LizergyLifeCycleState {
  /**
   * The element is active. It can be used.
   */
  Active,

  /**
   * The element is near the end of life. Consider replacing with active elements
   */
  NearEndOfLive,

  /**
   * The element is no longer supported.
   * It has been supported - but is no longer
   */
  EndOfLife,

  ;

  /**
   * Returns the combined ("worst") life cycle from two life cycles.
   *
   * Only returns [Active] if both are [Active]
   */
  fun and(other: LizergyLifeCycleState?): LizergyLifeCycleState {
    if (other == null) {
      return this
    }

    if (this == EndOfLife || other == EndOfLife) {
      return EndOfLife
    }

    if (this == NearEndOfLive || other == NearEndOfLive) {
      return NearEndOfLive
    }

    require(this == Active && other == Active) {
      "Unexpected combination this: <$this> other: <$other>"
    }

    return Active
  }

  fun isActive(): Boolean {
    return this == Active
  }

  fun isNearEndOfLive(): Boolean {
    return this == NearEndOfLive
  }

  fun isNotEndOfLife(): Boolean {
    return this != EndOfLife
  }

  fun isEndOfLife(): Boolean {
    return this == EndOfLife
  }

  fun format(): String {
    //TODO add i18n
    return when (this) {
      Active -> true.toCheckboxChar()
      NearEndOfLive -> "Veraltet"
      EndOfLife -> false.toCheckboxChar()
    }
  }

}
